import actions from './actions';
import getters from './getters';
import mutations from './mutations';




const state = {
    displayType: "desktop",
    windowWidth: 0,
    windowHeight: 0,
    offsetY: 0,
    navVisible: false,
    showCookie: true,
    contactFormAvailable: true,


};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};


// WEBPACK FOOTER //
// ./src/store/system/index.js